import {useEffect, useState} from "react";

export function GameInfo(props: any) {
    const game: any = props.game;

    const [gameInfo, setGameInfo] = useState<any>(null);

    useEffect(() => {
        setGameInfo(game);
    }, [game]);

    return (
        <>
            <div className={`game-info ${gameInfo?.code}`}>
                <div>
                    <h1 className={"text-start fw-bold fs-5"}>{gameInfo?.name ?? "Şans"} Oyunu</h1>
                </div>
                <div className={"white-space-normal"}>
                    {gameInfo && gameInfo?.description ? (
                        <p dangerouslySetInnerHTML={{
                            __html: game.description.replaceAll("\n", "<br/>"),
                        }}></p>
                    ) : (
                        <p>
                            Şans Oyunları, Milli Piyango İdaresince belirlenen usul ve esaslar dahilinde üyelerimize
                            sunulan
                            oyunlardır. Milli Piyango İdaresi güvencesiyle düzenlenmektedir. 320 sayılı Kanun Hükmünde
                            Kararname
                            hükümleri uyarınca, idare tarafından tertiplenen Karşılığı Nakit Olmayan Oyunlar için
                            taahhüt edilen
                            ikramiyeler, devlet garantisi altındadır. Şans Oyunları menüsünden oynayacağınız tüm
                            oyunlar, karşılığı
                            nakit olmayan oyunlardır: Çekilemez bakiye ödülleri... ( Çekilemez bakiyelerinizi Eşya
                            Piyangosu, Şans
                            Oyunlarında ve Ödül Kataloğunda kullanabilirsiniz.)
                        </p>
                    )}
                </div>
            </div>
        </>
    );
}